import { render, staticRenderFns } from "./cell-translation-job-created.vue?vue&type=template&id=23f796da&scoped=true"
import script from "./cell-translation-job-created.ts?vue&type=script&lang=ts&external"
export * from "./cell-translation-job-created.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-translation-job-created.vue?vue&type=style&index=0&id=23f796da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f796da",
  null
  
)

export default component.exports